module.exports = "<p>\n  description works!\n</p>\n"